import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import rcLogo from '../assets/logo/rc_logo.png';

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleSearch = (e) => {
        if (e.key === 'Enter' && searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();

            // Search mapping - keywords to routes/sections
            const searchMap = {
                'service': '/services',
                'services': '/services',
                'led': '/services',
                'neon': '/services',
                'signage': '/services',
                'branding': '/services',
                'vehicle': '/services',
                'wrapping': '/services',
                'exhibition': '/services',
                'wayfinding': '/services',
                'project': '/projects',
                'projects': '/projects',
                'work': '/projects',
                'works': '/projects',
                'portfolio': '/projects',
                'gallery': '/projects',
                'contact': '/contact',
                'email': '/contact',
                'phone': '/contact',
                'address': '/contact',
                'about': '/#about',
                'who we are': '/#about',
                'company': '/#about',
                'home': '/',
            };

            // Find matching route
            let targetRoute = null;
            for (const [keyword, route] of Object.entries(searchMap)) {
                if (query.includes(keyword)) {
                    targetRoute = route;
                    break;
                }
            }

            if (targetRoute) {
                // Navigate to the route
                if (targetRoute.startsWith('/#')) {
                    // Handle hash navigation
                    const hash = targetRoute.substring(1);
                    if (location.pathname !== '/') {
                        window.location.href = targetRoute;
                    } else {
                        const target = document.querySelector(hash);
                        if (target) {
                            window.scrollTo({
                                top: target.offsetTop - 150,
                                behavior: 'smooth'
                            });
                        }
                    }
                } else {
                    window.location.href = targetRoute;
                }
                setSearchQuery('');
            } else {
                // Default to services page if no match
                window.location.href = '/services';
                setSearchQuery('');
            }
        }
    };

    const handleNavClick = (e, targetId) => {
        // Only prevent default if we're on the home page and targeting an ID
        if (location.pathname === '/' && targetId.startsWith('#')) {
            e.preventDefault();
            const target = document.querySelector(targetId);
            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 150, // Offset for header height
                    behavior: 'smooth'
                });
            }
        }
        closeMenu();
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        closeMenu();
    };

    return (
        <header className="header-wrapper">
            {/* Top Bar */}
            <div className="top-bar">
                <div className="top-bar-container">
                    <div className="top-contact-item">
                        <div className="icon-box">
                            <Mail size={20} />
                        </div>
                        <div className="contact-text-group">
                            <span className="contact-label">Email us</span>
                            <a href="mailto:sales@rainbowcraft.ae" className="contact-value">sales@rainbowcraft.ae</a>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <div className="top-contact-item">
                        <div className="icon-box">
                            <Phone size={20} />
                        </div>
                        <div className="contact-text-group">
                            <span className="contact-label">Call us</span>
                            <a href="tel:+971569004913" className="contact-value">+971 50 860 4485</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Navbar */}
            <nav className="navbar">
                <div className="nav-brand">

                    <Link to="/" onClick={scrollToTop}>
                        <img src={rcLogo} alt="Rainbow Craft Signs & Graphics LLC - UAE" className="brand-logo" />
                    </Link>
                </div>

                <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                    <Link to="/" className="nav-link" onClick={scrollToTop}>Home</Link>

                    {location.pathname === '/' ? (
                        <a href="#about" className="nav-link" onClick={(e) => handleNavClick(e, '#about')}>About us</a>
                    ) : (
                        <Link to="/#about" className="nav-link" onClick={closeMenu}>About us</Link>
                    )}

                    <Link to="/services" className="nav-link" onClick={scrollToTop}>Services</Link>
                    <Link to="/projects" className="nav-link" onClick={scrollToTop}>Our works</Link>
                    <Link to="/contact" className="nav-link" onClick={scrollToTop}>Contact us</Link>
                </div>

                <div className="nav-actions">
                    <div className="nav-search">
                        <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                        <input
                            type="text"
                            placeholder="Search here...."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={handleSearch}
                        />
                    </div>
                    <Link to="/contact" className="nav-btn" onClick={scrollToTop}>LET'S TALK <span>›</span></Link>
                </div>

                <div className="hamburger" onClick={toggleMenu}>
                    <span style={{ transform: isMenuOpen ? 'rotate(45deg) translateY(6px)' : 'none' }}></span>
                    <span style={{ opacity: isMenuOpen ? '0' : '1' }}></span>
                    <span style={{ transform: isMenuOpen ? 'rotate(-45deg) translateY(-6px)' : 'none' }}></span>
                </div>
            </nav>
        </header>
    );
}

export default Navbar;
